<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import Icon from "@components_v2/Icon.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";

    export let rate: number;
    export let reviewCount: number;
    export let allReviewsCount: number;

    export let height = 12;
    export let width = 12;

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();

    $: percentage = (reviewCount / allReviewsCount) * 100;
</script>

<li class="gw-rv-rate-progress">
    <div class="gw-rv-rate-progress__stars-container">
        <p class="gw-rv-rate-progress__stars-text">{rate}</p>
        <Icon
            {width}
            {height}
            title="star rating icon"
            class="gw-rv-rate-progress__stars-icon"
        >
            <svelte:component this={$iconCollection$?.filled} />
        </Icon>
    </div>
    <div
        class="gw-rv-rate-progress__bar-container"
        role="progressbar"
        aria-label="Rating"
        aria-valuemin={0}
        aria-valuemax={allReviewsCount}
        aria-valuenow={reviewCount}
        aria-valuetext="1%"
    >
        <span style="width: {percentage}%" class="gw-rv-rate-progress__bar" />
    </div>
    <span class="gw-rv-rate-progress__text">{`${reviewCount}`}</span>
</li>

<style lang="postcss">
    .gw-rv-rate-progress {
        display: flex;
        width: 100%;
        align-items: center;
        line-height: initial;

        &:first-child {
            margin-top: 0;
        }

        &:hover {
            opacity: 0.8;
        }

        &__bar-container {
            border-radius: 2px;
            overflow: hidden;
            position: relative;
            width: 100%;
            height: 8px;
            margin: 0 10px;
            background: var(--gw-rv-progress-bar-bg);
        }

        &__bar {
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: var(--gw-rv-icon-starColor);
        }

        &__stars-container {
            display: flex;
            align-items: center;
            gap: 2px;
        }

        &__stars-text {
            margin: 0;
        }

        :global(&__stars-icon) {
            color: inherit;
        }
    }
</style>
